import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export var SET_NAVIGATION = 'SET_NAVIGATION';
export var SET_NAVIGATION_SERVICES = 'SET_NAVIGATION_SERVICES';